import { render, staticRenderFns } from "./MergeDuplicates.vue?vue&type=template&id=764fc2ad"
import script from "./MergeDuplicates.vue?vue&type=script&lang=js"
export * from "./MergeDuplicates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports